// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcumb[data-v-68d816e2]{width:100%;height:60px;z-index:10}.breadcumb .el-breadcrumb[data-v-68d816e2]{width:100%;line-height:60px}.breadcumb .el-breadcrumb .el-breadcrumb__item[data-v-68d816e2]{height:2vh}.breadcumb .el-breadcrumb .el-breadcrumb__item .el-breadcrumb__inner a[data-v-68d816e2]{font-weight:500}", ""]);
// Exports
module.exports = exports;
